import {Injectable} from '@angular/core';

@Injectable()
export class ValidationService {

    static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
        let config = {
            'required': 'Este campo es obligatorio.',
            'email': 'No es un email valido.',
            'invalidPassword': 'Password invalido. El password debe al menos 6 caracteres, y contener un numero.',
            'minlength': `Este campo debe tener al menos ${validatorValue.requiredLength} caracteres.`,
            'maxlength': `Este campo no debe tener mas de ${validatorValue.requiredLength} caracteres.`
        };
        return config[validatorName];
    }

    static passwordValidator(control) {
        // {6,100}           - Assert password is between 6 and 100 characters
        // (?=.*[0-9])       - Assert a string has at least one number
        if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
            return null;
        } else {
            return {'invalidPassword': true};
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/core/validation-messages/validation.service.ts